// A shared clock survives cart section morphs without restarting the countdown.
const key = 'milu-checkout-reminder-end';
let end;
try {
  end = Number(sessionStorage.getItem(key));
  if (!end) { end = Date.now() + 600000; sessionStorage.setItem(key, String(end)); }
} catch { end = Date.now() + 600000; }
function tick() {
  const seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));
  document.querySelectorAll('milu-cart-reminder').forEach(element => {
    const clock = element.querySelector('[data-clock]');
    if (clock) clock.textContent = `${Math.floor(seconds / 60).toString().padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`;
    element.hidden = !seconds;
    element.style.display = seconds ? '' : 'none';
  });
}
if (!customElements.get('milu-cart-reminder')) {
  customElements.define('milu-cart-reminder', class extends HTMLElement { connectedCallback() { tick(); } });
}
setInterval(tick, 1000);
document.addEventListener('visibilitychange', tick);
tick();
